/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import { ComponentProps } from 'react';

export default function LogoLight(props: ComponentProps<'svg'>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 80 28'
      fill='none'
      {...props}
    >
      <path
        fill='url(#a)'
        d='M12.1.58h4.16V21.9H12.1v-8.84H4.2v8.84H0V.58h4.2v8.47h7.9V.58Z'
      />
      <path
        fill='url(#b)'
        d='M31.58 6.67h3.92v15.24h-3.92v-1.8a5.96 5.96 0 0 1-4.95 2.22 6.95 6.95 0 0 1-5.23-2.31 8.15 8.15 0 0 1-2.16-5.73c0-2.26.72-4.15 2.16-5.7a6.9 6.9 0 0 1 5.23-2.34c2.12 0 3.77.74 4.95 2.22v-1.8ZM24.35 17.4c.79.79 1.79 1.19 3 1.19 1.22 0 2.22-.4 3.01-1.2a4.21 4.21 0 0 0 1.22-3.1c0-1.26-.4-2.29-1.22-3.08a4.02 4.02 0 0 0-3-1.22c-1.22 0-2.22.41-3.01 1.22a4.17 4.17 0 0 0-1.19 3.08c0 1.26.4 2.3 1.19 3.1Z'
      />
      <path
        fill='url(#c)'
        d='M47.9 6.25c2.05 0 3.79.78 5.23 2.34a7.98 7.98 0 0 1 2.19 5.7c0 2.25-.73 4.16-2.2 5.73a6.88 6.88 0 0 1-5.22 2.31 5.88 5.88 0 0 1-4.92-2.22V28h-3.92V6.67h3.92v1.8a5.88 5.88 0 0 1 4.92-2.22ZM44.16 17.4c.8.79 1.8 1.19 3.01 1.19 1.22 0 2.22-.4 3.01-1.2a4.21 4.21 0 0 0 1.22-3.1c0-1.26-.4-2.29-1.22-3.08a4.02 4.02 0 0 0-3-1.22c-1.22 0-2.23.41-3.02 1.22a4.17 4.17 0 0 0-1.18 3.08c0 1.26.4 2.3 1.18 3.1Z'
      />
      <path
        fill='url(#d)'
        d='M66.53 6.25c1.66 0 3.03.55 4.1 1.67 1.1 1.12 1.65 2.66 1.65 4.63v9.36h-3.93v-8.87c0-1.02-.27-1.79-.82-2.32a2.95 2.95 0 0 0-2.18-.82c-1.02 0-1.83.32-2.44.95-.6.63-.9 1.57-.9 2.83v8.23h-3.93V6.67H62v1.7c.95-1.41 2.46-2.12 4.53-2.12Z'
      />
      <path
        fill='url(#e)'
        d='M77.57 4.84a2.38 2.38 0 0 1-2.4-2.4c0-.65.23-1.22.7-1.7a2.33 2.33 0 0 1 3.4 0 2.34 2.34 0 0 1 0 3.41c-.47.46-1.03.7-1.7.7Zm-1.95 17.07V6.67h3.92v15.24h-3.92Z'
      />
      <defs>
        <linearGradient
          id='a'
          x1='40.15'
          x2='40.15'
          y1='-.63'
          y2='28.08'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset='.19'
            stopColor='#1E2248'
          />
          <stop
            offset='1'
            stopColor='#53199D'
          />
        </linearGradient>
        <linearGradient
          id='b'
          x1='40.15'
          x2='40.15'
          y1='-.63'
          y2='28.08'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset='.19'
            stopColor='#1E2248'
          />
          <stop
            offset='1'
            stopColor='#53199D'
          />
        </linearGradient>
        <linearGradient
          id='c'
          x1='40.15'
          x2='40.15'
          y1='-.63'
          y2='28.08'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset='.19'
            stopColor='#1E2248'
          />
          <stop
            offset='1'
            stopColor='#53199D'
          />
        </linearGradient>
        <linearGradient
          id='d'
          x1='40.15'
          x2='40.15'
          y1='-.63'
          y2='28.08'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset='.19'
            stopColor='#1E2248'
          />
          <stop
            offset='1'
            stopColor='#53199D'
          />
        </linearGradient>
        <linearGradient
          id='e'
          x1='40.15'
          x2='40.15'
          y1='-.63'
          y2='28.08'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset='.19'
            stopColor='#1E2248'
          />
          <stop
            offset='1'
            stopColor='#53199D'
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
